import { render, staticRenderFns } from "./CreateFeedbackHotline.vue?vue&type=template&id=3af5ca84&scoped=true&"
import script from "./CreateFeedbackHotline.vue?vue&type=script&lang=js&"
export * from "./CreateFeedbackHotline.vue?vue&type=script&lang=js&"
import style0 from "./CreateFeedbackHotline.vue?vue&type=style&index=0&id=3af5ca84&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af5ca84",
  null
  
)

export default component.exports